import styled from 'styled-components';

export const Heading = styled.h2`
  align-items: center;
  color: #979ca4;
  display: flex;
  height: 100%;
  justify-content: center;
`;
